import React, { useEffect, useState } from 'react';
import { API } from '@service';
import { Loading } from '@components';
import {
  PDFDownload,
  PDFTitle,
} from '@components/hubModule/pdfTitleAndDownload';
import { injectPDFStyleOnIframeLoad } from '@utils/common';
import { handleNameInitialsModuleBack } from '@utils/history';
import useObjectUrl from '@hooks/useObjectURL';
import { filterXSS } from 'xss';

const blobToBase64 = function (blob, callback) {
  const reader = new FileReader();
  reader.onload = function () {
    const dataUrl = reader.result;
    const base64 = dataUrl.split(',')[1];
    callback(base64);
  };
  reader.readAsDataURL(blob);
};

function UserGuideShared({ history }) {
  const [pdfContent, setPdfContent] = useState(null);
  useEffect(() => {
    (async () => {
      const requestApi = () => {
        const type = 'Share';
        return API.getUserGuideRequest(type);
      };
      const { fileName, data } = await requestApi();

      setPdfContent({ contentBlob: data, fileName });
      // blobToBase64(data, (b64) =>
      //   setPdfContent({ contentBlob: b64, fileName }),
      // );
    })();

    // return () => {
    //   URL.revokeObjectURL(pdfContent);
    // };
  }, []);

  const objectURL = useObjectUrl(pdfContent?.contentBlob);

  return (
    <div className="page-wrapper integration-iframe-page project">
      <span
        className="dd-back-btn"
        // onClick={() => {
        //   history.goBack();
        //   setTimeout(() => {
        //     window.location.reload();
        //   }, 1000);
        // }}
        onClick={() => handleNameInitialsModuleBack(history)}
      >
        <span className="appkiticon icon-left-chevron-fill a-font-12" /> Back
      </span>
      <div
        className="project-form-title"
        style={{ marginTop: '1.5rem', marginBottom: '2rem' }}
      >
        User Guide
      </div>

      <div
        className="shared-guide-wrapper"
        id="iframe-pdf-container"
        style={{ position: 'relative' }}
      >
        {pdfContent ? (
          <>
            <PDFTitle pdfContent={pdfContent} style={{ width: '33%' }} zoomed />
            <PDFDownload pdfContent={pdfContent} zoomed />
            <iframe
              style={{ paddingTop: '1.875rem !important' }}
              title="User Guide.pdf"
              // src={`data:application/pdf;base64,${pdfContent.contentBlob}`} // use b64 to prevent reload on launch; otherwise history.goBack() won't work
              src={filterXSS(objectURL)}
              onLoad={injectPDFStyleOnIframeLoad}
            />
          </>
        ) : (
          <Loading style={{ textAlign: 'center', marginTop: '10%' }} />
        )}
      </div>
    </div>
  );
}

export default UserGuideShared;
